// 한국어(비공식 번역・機械翻訳。ネイティブ確認推奨). 곡명 등 고유명사는 원문 그대로 표기.
import type { SiteDict } from "./ja";
import type { RelativeDate } from "../../../utils/postMeta";

const ko: SiteDict = {
  site: {
    titleSuffix: "!Legit - Reol 비공식 팬사이트",
    topTitle: "!Legit｜Reol의 모든 곡·라이브·세트리스트를 망라한 비공식 팬사이트",
    defaultDescription: (years: number) =>
      `Reol(れをる)의 비공식 팬사이트. 모든 곡의 라이브 공연 통계, 역대 라이브 세트리스트, MV 촬영지(성지) 지도, 팬 유형 테스트까지. ${years}년간의 활동을 한 번에 검색할 수 있습니다.`,
    breadcrumbHome: "홈",
  },
  header: {
    search: "검색",
    searchTitle: "곡·라이브·촬영지 통합 검색",
    toDark: "다크 모드로 전환",
    toLight: "라이트 모드로 전환",
    myPage: "마이페이지",
    menu: "메뉴",
    language: "언어",
  },
  footer: {
    officialSite: "공식 사이트",
    goods: "굿즈",
    disclaimer:
      "이 사이트는 Reol 공식과 관계없는 비공식 팬사이트입니다. 음원·영상은 공식 임베드/링크만 사용합니다.",
    operator: "운영(비공식 팬사이트)",
    privacy: "개인정보 처리방침(일본어)",
    mtNotice: "이 페이지는 일본어를 기계 번역한 것입니다. 번역 오류나 어색한 표현을 발견하시면 알려 주세요:",
    mtContact: "X @twilightplc",
  },
  video: {
    close: "영상 닫기",
    play: "영상 재생",
    back: "영상 위치로",
    playing: "오른쪽 위에서 재생 중",
    region: "재생 중인 영상",
  },
  home: {
    heroLine1Before: "Reol의 ",
    heroLine1Accent: "지금까지",
    heroLine1After: "와",
    heroLine2Indent: "Reol의 ",
    heroLine2Accent: "앞으로",
    heroLine2After: "를 만나다.",
    heroEmMobile: 7.6,
    heroEmWide: 9.8,
    heroLead1: "곡·라이브·세트리스트·촬영지. 「れをる」 시절부터 현재까지,",
    heroLead2: "공식 콘텐츠로 안내하는 역할도 겸한 비공식 아카이브.",
    ticketCta: "공식 사이트에서 티켓 →",
    // HOME の NEW RELEASE(plan/60)
    listenCta: "디스코그래피에서 보기 →",
    welcomeTitle: "처음 만나는 Reol",
    welcomeDesc: "대표곡과 시기별 가이드. 어느 시기부터 입문해도 헤매지 않아요.",
    liveTitle: "라이브 보러 가기",
    liveDesc: (n: number) => `${n}회 공연의 세트리스트 아카이브와 첫 참가 가이드.`,
    liveGuideLink: "첫 참가 가이드 읽기 →",
    dataTitle: "데이터 파고들기",
    dataDesc: (n: number) => `전체 ${n}곡의 공연 횟수·첫 공연·최근 공연을 수록.`,
    timemachineTitle: "타임머신",
    timemachineDesc: "연월 슬라이더로 당시의 곡 수·공연 수·연주 횟수를 재현.",
    cgraphTitle: "크리에이터 관계도",
    cgraphDesc: "곡 제작에 참여한 크리에이터들의 관계를 시각화.",
    heatmapTitle: "공연 지역 지도",
    heatmapDesc: "도도부현별 공연 수를 색으로 구분한 히트맵.",
    sorterTitle: "곡 소터",
    sorterDesc: "두 곡씩 겨루는 토너먼트로 당신의 최애곡을 결정.",
    grammarTitle: "세트리스트 문법",
    grammarDesc: "곡의 인접 관계·고정 위치·연도별 경향을 데이터로 분석.",
    compareTitle: "세트리스트 비교",
    compareDesc: "두 공연의 세트리스트를 비교해 공통 곡·차이·곡 순서 변화를 시각화.",
    tourHeatmapTitle: "투어 히트맵",
    tourHeatmapDesc: "한 투어의 모든 공연을 가로질러 곡별 연주 여부·곡 순서를 한눈에 표시.",
    similarityTitle: "세트리스트 유사도 랭킹",
    similarityDesc: "서로 다른 투어 사이에서 세트리스트가 특히 비슷한 공연 조합 랭킹.",
    postsTitle: "관련 게시물",
    postsDesc: "곡·라이브·각 공연의 관련 게시물을 시간순으로 모아 표시.",
    quizTitle: "Reol 팬 유형 테스트",
    quizDesc: "20개의 질문으로 당신의 팬 유형을 진단!",
    guideTitle: "라이브 참가 가이드",
    guideDesc: "준비물·복장·매너부터 원정 요령까지",
  },
  explore: {
    kicker: "EXPLORE — 주요 콘텐츠",
    discography: "릴리스와 전곡 정보",
    live: "공연 정보·세트리스트",
    place: "촬영지 지도",
    photo: "포토 갤러리",
  },
  otd: {
    yesterday: "어제",
    dayBeforeYesterday: "그저께",
    daysAgo: (n: number) => `${n}일 전`,
    tomorrow: "내일",
    dayAfterTomorrow: "모레",
    daysLater: (n: number) => `${n}일 후`,
    releaseSuffix: " 발매",
    releaseTitle: (title: string) => `『${title}』`,
    kickerMonth: "ON THIS MONTH — 이달의 기록",
    kickerDay: "ON THIS DAY — 오늘은 무슨 날",
    yearsAgoToday: (years: number) => `${years}년 전 오늘`,
    anniversaryIn: (when: string, years: number) => `${when} ${years}주년`,
    anniversaryWas: (when: string, years: number) => `${when} ${years}주년이었어요`,
    monthEntry: (md: string, years: number) => `${md}(${years}년 전)`,
    upcoming: (days: number, years: number) => `${days}일 후 ${years}주년`,
    seeAll: "이날의 모든 기록 보기 →",
  },
  common: {
    postTiming: (kind: "live" | "release", rel: RelativeDate): string => {
      const ref = kind === "live" ? "공연" : "발매";
      if (rel.unit === "same") return `${ref} 당일`;
      const unit = rel.unit === "day" ? "일" : rel.unit === "month" ? "개월" : "년";
      return `${ref} ${rel.amount}${unit} ${rel.direction === "before" ? "전" : "후"}`;
    },
    postCategory: { 本人: "본인", 公式: "공식", メディア: "미디어" } as Record<string, string>,
    showMore: (n: number) => `더 보기 (${n}개)`,
    backToTop: "페이지 맨 위로",
    backHome: "HOME으로 돌아가기",
    loading: "불러오는 중...",
    loadError: (err: string) => `불러오지 못했습니다: ${err}`,
  },
  discography: {
    intro: "DISCOGRAPHY에서는 지금까지의 릴리스 정보와 커버 영상 등을 시간순으로 소개합니다.",
    metaDescription: "Reol의 지금까지의 릴리스 정보와 커버 영상 등을 시간순으로 소개. 각 곡의 링크도 확인할 수 있습니다.",
    collectionLabel: "컬렉션(보유/시청 완료)",
    collectionHint: "각 카드의 「✓」로 보유/시청 완료를 기록할 수 있습니다(이 기기의 브라우저에만 저장)",
    count: (n: number) => `${n}건`,
    unknownYear: "알 수 없음",
    helpFilter: "위쪽의 해시태그를 누르면 목록을 간단히 필터링할 수 있습니다",
    helpFilterExample: "예) 「#れをる」를 누르면 「れをる」 명의의 정보만 표시됩니다",
    helpPlayBefore: "제목 왼쪽의",
    helpPlayAfter: "를 탭하면 화면 위쪽 플레이어에서 영상이 재생됩니다",
    helpOpenBefore: "「",
    helpOpenAfter: "열기」를 누르면 수록곡 목록과 곡별 링크가 표시됩니다",
    helpCommentBefore: "곡명 오른쪽에 「",
    helpCommentAfter: "」가 표시된 경우, 클릭하면 Spotify 링크와 곡 분석 정보가 표시됩니다",
    detail: "상세",
    detailTitle: "곡 상세 페이지(공연 통계·MV·관련 게시물) 보기",
    markOwned: "보유/시청 완료로 표시",
    unmarkOwned: "보유에서 제외",
    owned: "보유 중",
    ownedCount: (n: number) => `${n}명이 보유/시청 완료`,
    tracks: "수록곡",
    copied: "복사했습니다",
    copyTitles: "곡명 복사",
    interview: "인터뷰",
    relatedPosts: "관련 게시물",
  },
  formats: {
    SG: "싱글",
    配信SG: "디지털 싱글",
    EP: "EP",
    miniAL: "미니 앨범",
    fullAL: "정규 앨범",
    "DVD/BD": "DVD/BD",
    MV: "MV",
    歌ってみた: "커버",
    LP: "LP",
  },
  live: {
    metaDescription: "Reol이 지금까지 출연한 단독 라이브·투어·페스티벌 정보. 공연별 세트리스트, 리포트, 관련 게시물을 소개합니다.",
    intro1: "LIVE에서는 지금까지 출연한 단독 라이브와 투어, 페스티벌 등의 정보를 소개합니다.",
    intro2: "공연별 세트리스트와 관련 게시물, 라이브 리포트 등을 실어, 참가하지 못한 공연도 어떤 분위기였는지 조금이나마 느낄 수 있도록 했습니다.",
    attendanceLabel: "참전 기록",
    attendanceHint: "각 공연 카드의 「✓」로 참전 완료를 기록할 수 있습니다(이 기기의 브라우저에만 저장)",
    heardLabel: "라이브로 들은 곡",
    heardHint: "참전 완료로 표시한 공연의 세트리스트로 집계합니다(라이브에서 연주된 적이 있는 곡이 대상)",
    heardList: (n: number) => `들은 곡 (${n})`,
    unheardList: (n: number) => `아직 라이브로 못 들은 곡 (${n}, 연주 횟수순)`,
    ongoing: "개최 중",
    upcoming: "개최 예정",
    helpFilter: "위쪽의 해시태그를 누르면 목록을 간단히 필터링할 수 있습니다",
    helpFilterExample: "예) 「#れをる」를 누르면 「れをる」 명의의 정보만 표시됩니다",
    helpDetailBefore: "「",
    helpDetailAfter: " 상세」를 누르면 라이브 리포트와 개최 장소, 세트리스트, 관련 게시물 등의 정보가 표시됩니다",
    tagEvent: "이벤트 출연",
    tagOneman: "단독 라이브",
    count: (n: number) => `${n}건`,
    unknownYear: "알 수 없음",
    setlistCopyTitle: (title: string) => `${title} 세트리스트`,
    markAttended: "참전 완료로 표시",
    unmarkAttended: "참전 완료에서 제외",
    attended: "참전 완료",
    attendedInYear: (n: number) => `참전 ${n}회`,
    showCount: (n: number) => `${n}공연`,
    songCount: (n: number) => `${n}곡`,
    detailTitle: "이 공연의 상세 페이지(세트리스트·공연장·관련 게시물) 보기",
    detail: "상세",
    youtubePlaylist: "YouTube 재생목록",
    attendedCount: (n: number) => `${n}명이 참전 완료`,
    setlist: "세트리스트",
    copied: "복사했습니다",
    copy: "복사",
    songPageTitle: "곡 상세 페이지 보기",
    songStatsTitle: "곡 통계 페이지에서 공연 이력 보기",
    noSetlist: "세트리스트 정보가 아직 등록되지 않았습니다",
    toShowPage: "공연 상세 페이지 보기",
    spoilerBadgeTitle: "진행 중인 투어입니다. 세트리스트 스포일러 주의",
    spoilerBadge: "⚠ 스포일러 주의",
    expand: "펼치기",
    spoilerNoticeTitle: "⚠ 스포일러 주의",
    spoilerNotice1: "이 투어는 현재 진행 중입니다.",
    spoilerNotice2: "세트리스트와 관련 게시물에는 스포일러가 포함되어 있습니다.",
    spoilerNotice3: "내용을 확인한 후 보시기 바랍니다.",
    showSpoiler: "스포일러를 감수하고 표시하기",
    relatedPosts: "관련 게시물",
  },
  song: {
    shareText: (song: string) => `Reol 「${song}」의 공연 통계·MV·스트리밍 링크 | !Legit(비공식 팬사이트)`,
    totalPlays: "누적 공연",
    playsValue: (n: string) => `${n}회`,
    firstPlayed: "첫 공연",
    lastPlayed: "최근 공연",
    album: "수록 앨범:",
    lyrics: "작사",
    music: "작곡",
    stream: "스트리밍으로 듣기",
    lyricsLink: "가사 보기(歌ネット, 일본어)",
    watchMv: "공식 MV 보기",
    articles: "이 곡에 관한 글(일본어)",
    shareTitle: "이 곡의 페이지를 X에 공유",
    share: "X에 공유",
    historyKicker: (n: string) => `PERFORMANCE HISTORY — ${n}건`,
    noHistoryTitle: "아직 라이브 공연 기록이 없습니다",
    noHistoryDesc: "앞으로 라이브에서 공연되면 이곳에 공연 이력이 추가됩니다.",
    venueTbd: "공연장 미정",
    closeVideo: "닫기",
    watchVideo: "영상 보기",
    relatedPosts: "관련 게시물",
    toStatsTitle: "곡 통계로",
    toStatsDesc: "모든 곡의 공연 횟수·첫 공연·최근 공연을 한눈에 보기.",
    toSearchTitle: "통합 검색으로",
    toSearchDesc: "곡·라이브·촬영지를 가로질러 키워드로 검색.",
    backToTop: "홈으로 돌아가기",
    metaLead: (song: string) => `Reol 「${song}」의 라이브 공연 통계.`,
    metaPlays: (n: number, first: string | null) => ` 누적 ${n}회 공연, 첫 공연은 ${first ?? "알 수 없음"}.`,
    metaNoPlays: " 라이브 공연 기록은 확인되지 않았습니다.",
    metaTail: " 공연 이력·공식 MV·스트리밍 링크를 소개합니다.",
    breadcrumbStats: "곡 통계",
  },
  show: {
    setlistCopyTitle: (title: string) => `${title} 세트리스트`,
    shareText: (heading: string) => `Reol 「${heading}」의 세트리스트·공연장 정보 | !Legit(비공식 팬사이트)`,
    venue: "공연장",
    venueSite: "공연장 사이트 보기",
    reliveTitle: "Relive Player (β) — 이 세트리스트를 로컬 음원으로 재생합니다",
    relive: "Relive Player (β·음원 직접 준비)",
    shareTitle: "이 공연의 페이지를 X에 공유",
    share: "X에 공유",
    mapTitle: (heading: string) => `공연장 지도 - ${heading}`,
    setlistKicker: (n: number) => `SETLIST — ${n}곡`,
    mcCount: (n: number) => ` (MC ${n})`,
    copied: "복사했습니다",
    copy: "복사",
    noSetlistTitle: "세트리스트 정보가 아직 등록되지 않았습니다",
    noSetlistDesc: "정보가 확인되는 대로 추가하겠습니다.",
    closeVideo: "닫기",
    watchVideo: "영상 보기",
    venueTbd: "공연장 미정",
    relatedPosts: "관련 게시물",
    toArchiveTitle: "LIVE 아카이브 목록으로",
    toArchiveDesc: "역대 라이브의 세트리스트·공연 정보를 한눈에 보기.",
    toSearchTitle: "통합 검색으로",
    toSearchDesc: "곡·라이브·촬영지를 가로질러 키워드로 검색.",
    backToTop: "홈으로 돌아가기",
    metaLead: (name: string) => `Reol 「${name}」의 공연 정보.`,
    metaVenue: (place: string) => ` 공연장: ${place}.`,
    metaSetlist: (n: number) => ` 세트리스트 ${n}곡 수록.`,
  },
  stats: {
    title: "곡 통계",
    metaDescription: "Reol 전곡의 라이브 공연 통계. 누적 공연 횟수·첫 공연일·최근 공연일을 한눈에 볼 수 있습니다.",
    lead: "라이브에서 공연된 곡의 누적 공연 횟수·첫/최근 공연일을 한눈에 봅니다.",
    rulesLink: "집계 규칙에 대해 →",
    totalPlays: "공연 수(누적)",
    uniqueSongs: "공연된 곡",
    searchPlaceholder: "🔍 곡명으로 검색",
    sortPlays: "공연 횟수(많은 순)",
    sortLast: "최근 공연(새로운 순)",
    sortFirst: "첫 공연(오래된 순)",
    sortName: "곡명",
    songCount: (n: string) => `${n}곡`,
    toSongPageTitle: "곡 상세 페이지로",
    firstPlayed: "첫 공연",
    lastPlayed: "최근",
    toAlbum: "수록 앨범 보기 →",
    toSongPage: "이 곡의 페이지로 →",
    watchMv: "▶ 공식 MV 보기",
    stream: "♪ 스트리밍으로 듣기",
    history: "공연 이력",
    historyCount: (n: number) => `(${n}건)`,
    noMatch: "해당하는 곡을 찾을 수 없습니다",
    backToTop: "← 홈으로 돌아가기",
    historyLoadError: "공연 이력을 불러오지 못했습니다",
    historyLoading: "공연 이력을 불러오는 중...",
    historyEmpty: "공연 이력이 없습니다",
  },
};

export default ko;
